import i18next from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const TRANSLATION_PATH = '/assets/locales/{{lng}}/{{ns}}.json';

i18next
  .use(I18NextHttpBackend)
  .use(initReactI18next)
  .init({
    backend: { loadPath: TRANSLATION_PATH },
    fallbackLng: 'en',
    load: 'languageOnly',
    react: {
      useSuspense: false,
    },
  });

export default i18next;
